import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { CLEAR_COMM_AUTOMOBILE_GARAGE_PLATES_STATE, 
    FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_FAILED,
    FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_PROGRESS, 
    FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_SUCCESS } 
from "./commAutoGaragePlatesActions";
import { defaultCommAutomobileGaragePlatesState } from "./commAutoGaragePlates.types";
import { CommAutomobileGaragePlatesActions } from ".";

export const CommAutomobileGaragePlatesReducer = (
  state: IStoreState["commAuto"]["garagePlate"] = defaultCommAutomobileGaragePlatesState,
  action: CommAutomobileGaragePlatesActions
) => {
  switch (action.type) {
    case FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.data = [];
      });
      return newState;
    }
    case FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_COMM_AUTOMOBILE_GARAGE_PLATES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.data = [];
      });
      return newState;
    }

    case CLEAR_COMM_AUTOMOBILE_GARAGE_PLATES_STATE: {
      return defaultCommAutomobileGaragePlatesState;
    }

    default: {
      return state;
    }
  }
};
